define("Ames.CheckoutUrl.CheckoutUrl", [
  "Ames.CheckoutUrl.CheckoutUrl.View",
], function (CheckoutUrlView) {
  "use strict";
 
  return {
    mountToApp: function mountToApp(container) {
      // Inject the Cart component onto the view so it can add lines,
      // clear the cart, and apply promotions when the route loads.
      // Cart is registered by the shopping application before extensions
      // mount, so it is available here.
      CheckoutUrlView.prototype.cart = container.getComponent("Cart");
 
      var pageTypeComponent = container.getComponent("PageType");
 
      var pageType = {
        name: "checkout_url",
        view: CheckoutUrlView,
        // Public path becomes /checkout-url
        // Meta checkout URL -> https://shopamestools.com/checkout-url?products=...&coupon=...
        routes: ["checkout-url"],
        options: {},
        defaultTemplate: {
          name: "ames_checkouturl_checkouturl.tpl",
          displayName: "Checkout URL",
        },
      };
 
      pageTypeComponent.registerPageType(pageType);
    },
  };
});
 
